import { render, staticRenderFns } from "./DisableP2PSaveVoiceSetting.vue?vue&type=template&id=b6ac5958&scoped=true"
import script from "./DisableP2PSaveVoiceSetting.vue?vue&type=script&lang=js"
export * from "./DisableP2PSaveVoiceSetting.vue?vue&type=script&lang=js"
import style0 from "./DisableP2PSaveVoiceSetting.vue?vue&type=style&index=0&id=b6ac5958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ac5958",
  null
  
)

export default component.exports